import React, { memo, useMemo } from "react";

import * as Typed from "./ShareButton.typed";
import styles from "./ShareButton.module.css";

import { isMobile } from "../utils/isMobile";
import SystemUpdate from "@material-ui/icons/SystemUpdate";
import ShareIcon from "@material-ui/icons/Share";

const ShareButton = memo<Typed.Props>(({ onMakeScreen }) => {
  const isMobileScreen = useMemo(() => {
    return isMobile();
  }, []);

  return isMobileScreen ? (
    <SystemUpdate className={styles["share-icon"]} onClick={onMakeScreen} />
  ) : (
    <ShareIcon className={styles["share-icon"]} onClick={onMakeScreen} />
  );
});

export { ShareButton };
